export const ASSIGNED = "Assigned";
export const CONFIRMED = "Confirmed";
export const APPLIED = "Applied";
export const DECLINED = "Declined";
export const CANCELLED = "Cancelled";
export const VIEWED = "Viewed";
export const NOTIFIED = "Notified";
export const NOT_NOTIFIED = "Not Notified";
export const NOT_ELIGIBLE = "Not Eligible";
export const REMOVED = "Removed";